import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';

// Configure Amplify with updated 4-stack backend infrastructure
export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_USER_POOL_ID || 'us-east-1_AdezeoFFd',
        userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '4ppq0glh313i19jv9pbct82o4c',
        identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID || 'us-east-1:990af3ec-d2cc-412a-900e-fa7f3f35e8e7',
        loginWith: {
          email: true,
        },
        signUpVerificationMethod: 'code',
        userAttributes: {
          email: {
            required: true,
          },
        },
        passwordFormat: {
          minLength: 8,
          requireLowercase: true,
          requireUppercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
        },
      },
    },
    API: {
      GraphQL: {
        endpoint: import.meta.env.VITE_GRAPHQL_ENDPOINT || 'https://zx2l2cfkgzerzaobtoppnuss3u.appsync-api.us-east-1.amazonaws.com/graphql',
        region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
        defaultAuthMode: 'userPool',
        apiKey: import.meta.env.VITE_API_KEY || 'da2-biizixnvi5dv5mp6fu76fx6eay',
      },
    },
  });
};

// Enhanced authentication service for 4-stack compatibility
export const validateTokenWithNewInfrastructure = async (): Promise<boolean> => {
  try {
    const session = await fetchAuthSession();
    return !!(session.tokens?.idToken && session.tokens?.accessToken);
  } catch (error) {
    console.error('Token validation failed:', error);
    return false;
  }
};

export const migrateUserSession = async (): Promise<void> => {
  try {
    const session = await fetchAuthSession({ forceRefresh: true });
    if (session.tokens?.idToken) {
      console.log('User session successfully migrated to new infrastructure');
    }
  } catch (error) {
    console.error('Session migration failed:', error);
    throw error;
  }
};

export const getAuthToken = async () => {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() || '';
  } catch (error) {
    console.error('Error getting auth token:', error);
    return '';
  }
};
